import React from "react";
import { PlusIconsOptions } from "../../../../components/buttons/IconButtons";
import LayoutThumbnailApp from "../Functionality/LayoutThumbnailApp";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Miniature of a layout structure for the Create Layout tab.
 *
 * @param {Object} type - Entry of LAYOUT_TYPE.
 */
const LayoutThumbnail = ({ type }) => {
    const { gridClassName, cells } = LayoutThumbnailApp({ type });

    return (
        <div className={gridClassName}>
            {cells.map((cell) => (
                <div key={cell.key} className={cell.className}>
                    {cell.add && <PlusIconsOptions className='btn-icon-svg-16px icon-color-primary-500' />}
                </div>
            ))}
        </div>
    );
};

export default LayoutThumbnail;
